const CACHE_KEY = ['user-info']


export default function getCacheKey() {
  return CACHE_KEY
}
